import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { OnChangeInput } from "src/@types/form";
import searchIcon from "src/assets/icons/search.svg";
import { FilteringItem } from "./FilteringItem";
import { filteringLabelsTrns, filteringTrns } from "./trns";
import { TEXT_INPUT_STYLE_VARIANTS } from "../FormField/constants";

interface Props {
  onChange: OnChangeInput;
  value: string;
}

export const SearchFilteringItem: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <FilteringItem
      label={t(filteringLabelsTrns.search)}
      icon={{ url: searchIcon }}
    >
      <input
        className={cn(TEXT_INPUT_STYLE_VARIANTS.primary, "!py-1.5 text-sm")}
        placeholder={t(filteringTrns.searchPlaceholder)}
        {...props}
      />
    </FilteringItem>
  );
};
